var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('download-csv',{attrs:{"data":_vm.table.items || []}},[_c('v-btn',_vm._g({attrs:{"disabled":!_vm.table.items,"large":"","icon":""}},tooltip),[_c('v-icon',[_vm._v("mdi-file-download-outline")])],1)],1)]}}])},[_c('span',[_vm._v("Download CSV")])])}
var staticRenderFns = []

export { render, staticRenderFns }